// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3rnRv","rootSuccess":"CompleteLink_rootSuccess__1MZLA","rootFailure":"CompleteLink_rootFailure__k3bC4","isDisabled":"CompleteLink_isDisabled__18BkQ"};